const reviews = [
  {
    name: 'Amara Okafor',
    location: 'Abuja, Nigeria',
    avatar: 'AO',
    avatarBg: 'bg-[#009E81]',
    stars: 5,
    text: "Sweetplate is honestly the best food delivery app I've used. My jollof rice arrived hot and on time, and I even earned tokens on my order. Absolutely love it!",
    tag: 'FOOD APP',
  },
  {
    name: 'Kofi Mensah',
    location: 'Accra, Ghana',
    avatar: 'KM',
    avatarBg: 'bg-[#D4970B]',
    stars: 5,
    text: "As a restaurant owner, the Vendor App has been a game-changer. Orders come in instantly, the dashboard is super clean, and customer support is always available.",
    tag: 'Vendor App',
  },
  {
    name: 'Taiwo Adeyemi',
    location: 'Port Harcourt, Nigeria',
    avatar: 'TA',
    avatarBg: 'bg-[#FF7B54]',
    stars: 5,
    text: "I started riding part-time and now it's my main income. The Rider App is simple to use, the GPS is accurate, and the earnings come in fast. No complaints!",
    tag: 'Rider App',
  },
  {
    name: 'Fatima Al-Hassan',
    location: 'Nairobi, Kenya',
    avatar: 'FA',
    avatarBg: 'bg-indigo-500',
    stars: 5,
    text: "I was sceptical at first about the token rewards system, but I've been using Sweetplate for 3 months and I've already earned a decent amount in SPC. Recommend!",
    tag: 'FOOD APP',
  },
  {
    name: 'Emmanuel Boateng',
    location: 'East Legon, Ghana',
    avatar: 'EB',
    avatarBg: 'bg-pink-500',
    stars: 5,
    text: "Ordered late at night and was surprised how quickly it arrived. The live tracking feature is brilliant — I knew exactly where my food was the entire time.",
    tag: 'FOOD APP',
  },
  {
    name: 'Ngozi Eze',
    location: 'Enugu, Nigeria',
    avatar: 'NE',
    avatarBg: 'bg-rose-500',
    stars: 5,
    text: "We signed up our restaurant 2 months ago and our delivery orders have tripled. The platform is smooth, and customers always come back. Very impressed!",
    tag: 'Vendor App',
  },
];

const tagColors = {
  'FOOD APP': 'bg-[#E6F7F4] text-[#009E81]',
  'Vendor App': 'bg-[#FFF8E6] text-[#A07000]',
  'Rider App': 'bg-[#FFF1EC] text-[#D94F25]',
};

export default function Testimonials() {
  return (
    <section className="bg-[#FAFAFA] py-16 md:py-24 px-4 sm:px-6">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-10 md:mb-16">
          <span className="inline-block bg-[#E6F7F4] text-[#009E81] text-xs font-bold uppercase tracking-widest px-4 py-1.5 rounded-full mb-4">
            Reviews
          </span>
          <h2 className="text-3xl md:text-5xl font-extrabold text-gray-900 leading-tight">
            Loved by thousands
          </h2>
          <p className="mt-4 text-gray-500 text-base md:text-lg max-w-xl mx-auto">
            Real stories from customers, vendors, and riders across Africa and beyond.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {reviews.map((r) => (
            <div
              key={r.name}
              className="bg-white rounded-2xl p-5 md:p-6 border border-gray-100 hover:border-[#009E81]/30 transition-all duration-300 flex flex-col gap-3 md:gap-4"
            >
              <div className="flex gap-0.5">
                {Array.from({ length: r.stars }).map((_, idx) => (
                  <i key={idx} className="ri-star-fill text-[#FFCD1A] text-sm" />
                ))}
              </div>
              <p className="text-sm text-gray-600 leading-relaxed flex-1">
                &ldquo;{r.text}&rdquo;
              </p>
              <div className="flex items-center gap-3 pt-2 border-t border-gray-100">
                <div className={`w-9 h-9 flex items-center justify-center rounded-full ${r.avatarBg} flex-shrink-0`}>
                  <span className="text-white text-xs font-bold">{r.avatar}</span>
                </div>
                <div className="flex-1 min-w-0">
                  <p className="text-sm font-bold text-gray-900 truncate">{r.name}</p>
                  <p className="text-xs text-gray-400 truncate">{r.location}</p>
                </div>
                <span className={`text-xs font-semibold px-2 py-1 rounded-full flex-shrink-0 ${tagColors[r.tag]}`}>
                  {r.tag}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
